import { ComponentPropsWithRef, ElementType, ReactNode } from "react"
import { cn } from "styles/cn"

export const Empty = ({
	className,
	children,
	Icon,
	title,
	description,
	...props
}: Omit<ComponentPropsWithRef<"section">, "title"> & {
	title?: ReactNode
	description?: ReactNode
	Icon?: ElementType
}) => {
	if (!Icon && !title && !description && !children) {
		return null
	}

	return (
		<section
			{...props}
			className={cn(
				"flex size-full flex-col items-center justify-center gap-4",
				className,
			)}
		>
			{Icon && <Icon className="size-30" aria-hidden />}
			{title && (
				<h2 className="font-headings text-2xl font-semibold">{title}</h2>
			)}
			{description && <p className="text-center text-navy-60">{description}</p>}
			{children}
		</section>
	)
}
